export type PlaceListView = 'inProgress' | 'completed';

// チェックボックスの切り替え。選ばれていた物件は選択から外し、選ばれていなかった物件は末尾に追加する
export function togglePlaceSelection(selectedPlaceIds: number[], placeId: number): number[] {
  if (selectedPlaceIds.includes(placeId)) {
    return selectedPlaceIds.filter(selectedPlaceId => selectedPlaceId !== placeId);
  }
  return selectedPlaceIds.concat([placeId]);
}

// 表示中の物件がすべて選択されているか。表示中が 0 件なら false
export function areAllDisplayedSelected(selectedPlaceIds: number[], displayedPlaceIds: number[]): boolean {
  if (displayedPlaceIds.length === 0) {
    return false;
  }
  return displayedPlaceIds.every(placeId => selectedPlaceIds.includes(placeId));
}

// 見出しのチェックボックスの切り替え。表示中がすべて選択済みなら表示中だけを選択から外し、そうでなければ表示中をすべて選択に加える。
// 表示されていない選択は変えない
export function toggleAllDisplayedSelection(selectedPlaceIds: number[], displayedPlaceIds: number[]): number[] {
  if (areAllDisplayedSelected(selectedPlaceIds, displayedPlaceIds)) {
    return selectedPlaceIds.filter(placeId => !displayedPlaceIds.includes(placeId));
  }
  const notYetSelected = displayedPlaceIds.filter(placeId => !selectedPlaceIds.includes(placeId));
  return selectedPlaceIds.concat(notYetSelected);
}

// 選択中の物件が 1 件以上あるときだけ下部バーを出す
export function isBulkBarVisible(selectedCount: number): boolean {
  return selectedCount > 0;
}

// 一覧を取得するときに、完了済の物件と進行中の物件のどちらを求めるかを決める
export function toCompletedQueryVariable(view: PlaceListView): boolean {
  if (view === 'completed') {
    return true;
  }
  return false;
}

// 一括更新で書き込む値。進行中の一覧では完了にし、完了済の一覧では進行中に戻す
export function toCompletedValueToWrite(view: PlaceListView): boolean {
  if (view === 'inProgress') {
    return true;
  }
  return false;
}

export function getBulkActionLabel(view: PlaceListView): string {
  if (view === 'completed') {
    return '選択を進行中に戻す';
  }
  return '選択を完了済として設定';
}

export function getBulkActionSuccessMessage(view: PlaceListView): string {
  if (view === 'completed') {
    return '進行中に戻しました';
  }
  return '完了済に設定しました';
}

// タグ反転ボタンの色。反転中は赤で目立たせる
export function getInvertTagsButtonColor(invertSelectedTags: boolean): 'red' | 'white' {
  if (invertSelectedTags) {
    return 'red';
  }
  return 'white';
}

// タグ反転ボタンの文言。押したときに切り替わる先の表示を示す
export function getInvertTagsButtonLabel(invertSelectedTags: boolean): string {
  if (invertSelectedTags) {
    return '選択したタグの物件を表示';
  }
  return '選択したタグ以外の物件を表示';
}

// 表示切り替えボタンの色。今表示している側のボタンだけを緑にする
export function getViewButtonColor(view: PlaceListView, buttonView: PlaceListView): 'normal' | 'white' {
  if (view === buttonView) {
    return 'normal';
  }
  return 'white';
}

// 下部バーを出している間は、一覧の末尾がバーに隠れないよう余白用のクラスを足す
export function getContainerClassName(bulkBarVisible: boolean): string {
  if (bulkBarVisible) {
    return 'PlaceListPage-container PlaceListPage-container_with_bulk_bar';
  }
  return 'PlaceListPage-container';
}
